<template>
  <div>
    <Nav current="我的公司"></Nav>
    <div class="content">
      <div class="title">编辑角色</div>
      <div class="form">
        <div class="form_item">
          <span class="item_name"> 角色名称</span>
          <input type="text" v-model="roleName" />
          <span class="xing">* 为必填项</span>
        </div>
        <div class="form_item">
          <span class="item_name">角色描述</span>
          <input type="text" v-model="roelDescribe" />
        </div>
      </div>
    </div>

    <el-row class="el-row">
      <el-button type="primary" class="el-button btnSty" @click="updateRole">保存</el-button>
      <el-button class="el-button btnret" @click="retSuper">返回</el-button>
    </el-row>
  </div>
</template>
<script>
import Nav from "@/components/Nav.vue";
import apiData from "@/config/api";
import http from "@/config/httpConfig";
export default {
  components: {
    Nav,
  },
  data() {
    return {
      roleName: "",
      roelDescribe: "",
      id:'',
    };
  },
  created() {
    this.getRoleList();
  },
  mounted() {},
  methods: {
    getRoleList() {
      let _this = this;
      _this.roleName  = _this.$route.query.name
      _this.roelDescribe = _this.$route.query.description
      _this.id = _this.$route.query.id 
    },
    updateRole() {
      var _this = this;
      let params={
          id: this.id,
          name: this.roleName,
          description: this.roelDescribe
      }
      if(_this.roleName != ""){
        http.put(apiData.updateRole, true, params, function (res) {
          if (res.data.code == 200) {
            _this.$message.success("修改成功!");
            _this.$router.go(-1);
          } else {
            _this.$message.error("修改失败!");
          }
        })
      }else{
            _this.$message.error("角色名称不能为空!");

      }
       

    },
    retSuper() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped lang="less">
.content {
  text-align: left;
  .title {
    width: 100%;
    height: 56px;
    line-height: 56px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    text-indent: 10px;
    float: left;
  }

  .form {
    .form_item {
      display: flex;
      width: 100%;
      height: 40px;
      line-height: 40px;
      text-indent: 10px;

      input {
        width: 200px;
        height: 30px;
        margin-top: 5px;
        background: transparent;
        border: 1px solid rgb(204, 204, 204);
        text-indent: 10px;
      }

      .xing {
        color: #ffba1a;
      }
    }

    .item_name {
      width: 160px;
      display: block;
      color: #666;
      padding-left: 10px;
    }

    .form_item:nth-child(odd) {
      background: #f8f8f8;
    }
  }
}
.el-row {
  text-align: center;
  height: 40px;
  width: 100%;
  margin: 200px 0;
}

.btnret:hover {
  background: #55c4b8;
  border: 1px solid #55c4b8;
  color: #f8f8f8;
}

.el-button {
  width: 200px;
  height: 40px;
  border: 1px solid #55c4b8;
  color: #55c4b8;
}

.btnSty {
  background: #55c4b8;
  border: 1px solid #55c4b8;

  color: #fff;
}
</style>
